var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2929 1.29289C10.6834 0.902369 11.3166 0.902369 11.7071 1.29289L14.7071 4.29289C15.0976 4.68342 15.0976 5.31658 14.7071 5.70711L5.70711 14.7071C5.51957 14.8946 5.26522 15 5 15H2C1.44772 15 1 14.5523 1 14V11C1 10.7348 1.10536 10.4804 1.29289 10.2929L10.2929 1.29289ZM9.41421 5L11 6.58579L12.5858 5L11 3.41421L9.41421 5ZM9.58579 8L8 6.41421L3 11.4142V13H4.58579L9.58579 8Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.56a55cc6ae77bea7aa596736ec3b0453.svg";
export { ForwardRef as ReactComponent };